import React from 'react';
import Filter from './filter/Filter';
import IndexSummary from './index-summary/IndexSummary';
import Chart from './chart';
import Footer from '../../../common/table/Footer';
import { I18n } from 'react-redux-i18n';

class Content extends React.Component {
  render() {
    return (
      <div className="d-flex flex-fill flex-column">
        <div className="px-20">
          <Filter />
        </div>
        <div className="d-flex flex-fill flex-column px-20">
          <div className="d-flex flex-fill flex-column">
            <IndexSummary />
            <Chart />
            <div className="powered-by-fiinTrade mt-auto text-right mb-0">
              {I18n.t('common.poweredByFiinTrade')}
              <a href="https://fiintrade.vn" target="_blank">
                FiinTrade
              </a>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    );
  }
}

export default Content;
